export class Service {
    libelle: string;
    direction_id: any;
    direction: string;
    private errorMessage: string;

    constructor() {
        this.libelle = "";
        this.direction_id = "";
        this.errorMessage = "";
    }

    canSave(): boolean {
        this.errorMessage = "";
        if (!this.direction_id) {
            this.errorMessage = "L'ID de la direction est requis.";
            return false;
        }
        if (!this.libelle.trim()) {
            this.errorMessage = "Le libellé est requis.";
            return false;
        }
        // Toutes les vérifications sont passées
        return true;
    }

    getErrorMessage(): string {
        return this.errorMessage;
    }
}
